import TaskIcon from 'app/assets/images/PerformanceReport/TaskIcon.svg';
import React from 'react';
import { customSwitch } from 'utils/customSwitchCase/customSwitch';
import { convertToHoursMinutes } from '../../Common/Helper/Helper';
import { TaskMetric } from './Tile';

export const getTaskKpiTileIcon = customSwitch({
  [TaskMetric.Outstanding]: <img src={TaskIcon} alt="Task" />,
  [TaskMetric.CancelledTask]: <img src={TaskIcon} alt="Task" />,
  [TaskMetric.AverageCompletionTime]: <img src={TaskIcon} alt="Task" />,
  [TaskMetric.Completed]: <img src={TaskIcon} alt="Task" />,
})(undefined);

export const getTaskGridTitle = customSwitch({
  [TaskMetric.Outstanding]: '# of Outstanding Tasks',
  [TaskMetric.Completed]: '# of Completed Tasks',
  [TaskMetric.AverageCompletionTime]: 'Avg. Time to Complete',
  [TaskMetric.CancelledTask]: '# of Cancelled Tasks',
})(undefined);

export const getTaskMetricChannel = customSwitch({})(undefined);

export const flattenedTaskTileData = TaskMetricsValue => {
  const taskKpi = TaskMetricsValue && TaskMetricsValue.find(kpi => kpi.channel === 'Task')?.kpis;
  return [
    {
      primaryLabel: TaskMetric.Outstanding,
      secondaryLabel: '',
      value: taskKpi && taskKpi.find(kpi => kpi.name === '# of Outstanding Tasks')?.count,
      showProgress: false,
      isSelected: false,
    },
    {
      primaryLabel: TaskMetric.Completed,
      secondaryLabel: '',
      value: taskKpi && taskKpi.find(kpi => kpi.name === '# of Completed Tasks')?.count,
      showProgress: false,
    },
    {
      primaryLabel: TaskMetric.AverageCompletionTime,
      secondaryLabel: '',
      value: convertToHoursMinutes(taskKpi && taskKpi.find(kpi => kpi.name === 'Avg. Time to Complete')?.rate),
      showProgress: false,
      disabled: false,
    },

    {
      primaryLabel: TaskMetric.CancelledTask,
      secondaryLabel: '',
      value: taskKpi && taskKpi.find(kpi => kpi.name === '# of Cancelled Tasks')?.count,
      showProgress: false,
    },
  ];
};
